class AudioService {
    constructor() {
        this.localSrc = '/audio/notice.mp3';
        this.remoteSrc = 'https://videotourl.com/audio/1779788976218-0e6d9099-637c-4942-a3da-abe947edec62.mp3';

        this.audio = new Audio(this.localSrc);
        this.audio.loop = false;

        this.isUsingRemote = false;

        this.initErrorListener();
    }

    initErrorListener() {
        this.audio.addEventListener('error', () => {
            if (!this.isUsingRemote) {
                console.warn("本地音频加载失败，正在尝试从线上地址加载...");
                this.isUsingRemote = true;
                this.audio.src = this.remoteSrc;
                this.audio.load();
            } else {
                console.error("本地和线上音频地址均加载失败。");
            }
        }, true);
    }

    play() {
        if (!this.audio) return;

        this.audio.currentTime = 0;

        const playPromise = this.audio.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
            }).catch(error => {
                if (error.name === 'NotAllowedError') {
                    console.warn("音频播放被拦截。提示：浏览器要求用户必须先与页面有过交互（如点击）才能自动播放音频。");
                } else {
                    console.error("音频播放出错:", error);
                }
            });
        }
    }

    stop() {
        if (this.audio) {
            this.audio.pause();
            this.audio.currentTime = 0;
        }
    }
}

// 导出单例
export default new AudioService();